import React from 'react';
import ReactDOM from 'react-dom';
import hoistStatics from 'hoist-non-react-statics';

let scrollHandlerBound = false;
let scrollCallbacks = [];
let timeout;
let lastId = 0;
const scrollHandler = () => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    scrollCallbacks.forEach(({ fn }) => fn());
  }, 50);
};
const CALLBACKS = {
  ON_ENTER: 'onDwellEnter',
  ON_LEAVE: 'onDwellLeave',
  ON_DWELL: 'onDwell',
};

let resetScrollStuff; // eslint-disable-line import/no-mutable-exports
if (__TEST__) {
  resetScrollStuff = () => {
    scrollCallbacks.length = 0;
    scrollHandlerBound = false;
    window.removeEventListener('scroll', scrollHandler, true);
    window.removeEventListener('resize', scrollHandler, true);
  };
}
export { resetScrollStuff };

export default (Component, { dwellTime = 1000, ...callbacks } = {}) => {
  class klass extends React.Component {
    componentDidMount() {
      if (!scrollHandlerBound) {
        scrollHandlerBound = true;
        window.addEventListener('scroll', scrollHandler, true);
        window.addEventListener('resize', scrollHandler, true);
      }
      scrollCallbacks.push({
        id: (lastId += 1),
        fn: this.onDwellScroll,
      });
      this.dwellScrollbackId = scrollCallbacks[scrollCallbacks.length - 1].id;
      this.wasInViewport = null;
      this.onDwellScroll();
    }

    componentWillUnmount() {
      scrollCallbacks = scrollCallbacks.filter(({ id }) => id !== this.dwellScrollbackId);

      if (scrollCallbacks.length === 0) {
        window.removeEventListener('scroll', scrollHandler, true);
        window.removeEventListener('resize', scrollHandler, true);
        scrollHandlerBound = false;
      }
    }

    onDwellScroll = () => {
      if (this.inViewport()) {
        if (this.wasInViewport !== true) {
          this.triggerCallback(CALLBACKS.ON_ENTER);
        }
        if (!this.dwellTimeout && !this.wasInViewport) {
          this.dwellTimeout = setTimeout(() => {
            this.dwellTimeout = null;
            if (this.inViewport()) {
              this.triggerCallback(CALLBACKS.ON_DWELL);
            }
          }, dwellTime);
        }
        this.wasInViewport = true;
      } else if (!this.inViewport() && this.wasInViewport !== false) {
        this.triggerCallback(CALLBACKS.ON_LEAVE);
        this.wasInViewport = false;
      }
    };

    setComponentNode = cmp => (this.componentNode = cmp);

    /* istanbul ignore next */
    inViewport = () => {
      if (this.componentNode) {
        // eslint-disable-next-line react/no-find-dom-node
        const node = ReactDOM.findDOMNode(this.componentNode);

        if (!node) {
          return false;
        }

        const rect = node.getBoundingClientRect();

        // This implementation will trigger if at least one pixel of the element is in the viewport
        return (
          rect.bottom > 0 &&
          rect.right > 0 &&
          rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
          rect.left < (window.innerWidth || document.documentElement.clientWidth)
        );
      }
    };

    triggerCallback = callbackName => {
      if (callbacks[callbackName]) {
        callbacks[callbackName]();
      }
      if (this.componentNode && this.componentNode[callbackName]) {
        this.componentNode[callbackName]();
      }
    };

    render() {
      return <Component ref={this.setComponentNode} {...this.props} />;
    }
  }

  klass.displayName = `fiveEyes(${Component.displayName || Component.name})`;

  return hoistStatics(klass, Component);
};
